module.exports = __webpack_public_path__ + "static/media/classScheduleIconHover.0b3e9695.svg";